import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

// import icone and img
import MessageText from "../../assets/svg/message-text.svg";
import Logo from "../../assets/svg/logo.svg";

const CustomLink = ({ to, title, className = "", href = "" }) => {
  const location = useLocation();
  return (
    <li>
      <Link
        to={to}
        href={href}
        className={`${className} text-lg relative group`}
      >
        {title}

        <span
          className={`h-0.5 inline-block bg-white absolute left-0 -bottom-1 group-hover:w-full transition-width ease duration-300 ${
            location.pathname === to ? "w-full" : "w-0"
          }`}
        >
          &nbsp;
        </span>
      </Link>
    </li>
  );
};

const CustomMobileLink = ({ to, title, className = "", toggle }) => {
  const location = useLocation();

  const handleClick = () => {
    toggle();
  };

  return (
    <li>
      <button onClick={handleClick}>
        <Link
          to={to}
          className={`${className} relative group text-lg text-white`}
        >
          {title}

          <span
            className={`h-0.5 inline-block bg-white absolute left-0 -bottom-1 group-hover:w-full transition-width ease duration-300 ${
              location.pathname === to ? "w-full" : "w-0"
            }`}
          >
            &nbsp;
          </span>
        </Link>
      </button>
    </li>
  );
};

const CustomAnchor = ({ title, className = "", href, aria }) => {
  const location = useLocation();

  return (
    <li>
      <a
        href={href}
        className={`${className} relative group text-lg text-white`}
        arial-label="link to id"
      >
        {title}
        <span
          className={`h-0.5 inline-block bg-white absolute left-0 -bottom-1 group-hover:w-full transition-width ease duration-300 ${
            location.pathname === href ? "w-full" : "w-0"
          }`}
        >
          &nbsp;
        </span>
      </a>
    </li>
  );
};

const CustomAnchorMobile = ({ title, className = "", href, toggle, aria }) => {
  const location = useLocation();
  const handleClick = () => {
    toggle();
  };

  return (
    <li>
      <button onClick={handleClick}>
        <a
          href={href}
          className={`${className} relative group text-lg text-white`}
          arial-label="link to id"
        >
          {title}
          <span
            className={`h-0.5 inline-block bg-white absolute left-0 -bottom-1 group-hover:w-full transition-width ease duration-300 ${
              location.pathname === href ? "w-full" : "w-0"
            }`}
          >
            &nbsp;
          </span>
        </a>
      </button>
    </li>
  );
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <section className=" bg-background">
      <header className="flex justify-between px-6 pt-8 items-center lg:px-16 relative">
        <motion.div
          initial={{ y: 25, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{
            duration: 3,
          }}
          className="flex justify-between w-full"
        >
          <div>
            <img width={159} height={60} src={Logo} alt="img logo" />
          </div>
          <nav>
            <ul className="font-medium text-white lg:flex lg:items-center lg:gap-x-14 hidden pt-3">
              <CustomAnchor href="#realisations" title="Réalisations" />

              <CustomAnchor href="#produits" title="Nos offres" />

              <CustomLink to="/about" title="À propos" />
              <li>
                <ul className="flex items-center space-x-3 bg-white text-bluetextcoming px-4 py-2 rounded-lg">
                  <CustomLink to="/contactez-nous" title="Contact" />
                  <li>
                    <img
                      height={18}
                      width={18}
                      src={MessageText}
                      alt="img message text"
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </motion.div>
        {isOpen ? (
          <nav className="min-w-[80vw] rounded-xl font-medium flex flex-col justify-between z-30 items-center fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2    lg:hidden bg-background/90 backdrop-blur-md py-32">
            <ul className="flex flex-col space-y-9 ">
              <CustomAnchorMobile
                href="#realisations"
                title="Réalisations"
                toggle={toggleMenu}
              />

              <CustomAnchorMobile
                href="#produits"
                title="Nos offres"
                toggle={toggleMenu}
              />

              <CustomMobileLink
                to="/about"
                title="À propos"
                toggle={toggleMenu}
              />
              <ul className="flex items-center space-x-3 bg-white  px-4 py-2 rounded-lg">
                <CustomMobileLink
                  className="text-bluetextcoming"
                  to="/contactez-nous"
                  title="Contact"
                  toggle={toggleMenu}
                />
                <img
                  height={18}
                  width={18}
                  src={MessageText}
                  alt="img message text"
                />
              </ul>
            </ul>
          </nav>
        ) : null}

        <button
          className=" flex-col justify-center items-center lg:hidden "
          onClick={toggleMenu}
          id="button-menu"
          aria-label="button-menu"
        >
          <span
            className={`bg-white block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm -translate-y-0.5 ${
              isOpen ? "rotate-45 translate-y-1" : "-translate-y-0.5"
            }`}
          ></span>
          <span
            className={`bg-white block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm my-0.5 ${
              isOpen ? "opacity-0" : "opacity-100"
            }`}
          ></span>
          <span
            className={`bg-white block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm translate-y-0.5 ${
              isOpen ? "-rotate-45 -translate-y-1" : "translate-y-0.5"
            }`}
          ></span>
        </button>
      </header>
    </section>
  );
};

export default Navbar;
